import Swiper from 'swiper'
import { Pagination } from 'swiper/modules'

class ProductSwiperComponent extends HTMLElement {
  constructor() {
    super()

    this.swiperEl = null
    this.swiperContainer = null
    this.swiperWrapper = null
    this.prevButton = null
    this.nextButton = null
    this.pagination = null
    this.swiper = null

    this.options = {
      modules: [Pagination],
      init: false,
      direction: 'horizontal',
      loop: false,
      threshold: 7,

      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: false,
      centerInsufficientSlides:
        this.getAttribute('center-insufficient-slides') === 'true' ? true : false,

      breakpoints: {
        320: {
          slidesPerView: 1,
        },
        650: {
          slidesPerView: 2,
        },
        1050: {
          slidesPerView: 3,
        },
        1680: {
          slidesPerView: 4,
        },
      },
    }
  }

  connectedCallback() {
    this.prepareTemplate()
    this.initSwiper()
    this.initControls()
    this.dispatchEvent(new CustomEvent('ready', { bubbles: false }))
  }

  prepareTemplate() {
    // Move children to temporary element
    const tempChildrenContainer = document.createElement('div')
    const children = this.children
    Array.from(children).forEach(child => {
      tempChildrenContainer.appendChild(child)
    })

    // Template
    const template = document.createElement('template')
    template.innerHTML = `
      <div class="product-swiper">
        <div class="swiper-container">
          <div class="swiper-wrapper"></div>
        </div>
        <div class="button-wrapper">
          <button class="custom-button button-prev"><span class="icon"></span></button>
          <div class="pagination"></div>
          <button class="custom-button button-next"><span class="icon"></span></button>
        </div>
      </div>
    `
    this.appendChild(template.content.cloneNode(true))

    // Get references
    this.swiperEl = this.querySelector('.product-swiper')
    this.swiperContainer = this.querySelector('.swiper-container')
    this.swiperWrapper = this.querySelector('.swiper-wrapper')
    this.prevButton = this.querySelector('.button-prev')
    this.nextButton = this.querySelector('.button-next')
    this.pagination = this.querySelector('.pagination')

    // Move slides into swiper-wrapper
    Array.from(tempChildrenContainer.children).forEach(child => {
      this.swiperWrapper.appendChild(child)
    })
  }

  initSwiper() {
    const swiperEl = this.swiperEl

    // Initial slide
    let initialSlide = this.getAttribute('initial-slide')
    if (initialSlide) this.options.initialSlide = initialSlide

    // Pagination
    this.options.pagination = {
      el: this.pagination,
      type: 'bullets',
      clickable: true,
    }

    this.swiper = new Swiper(this.swiperContainer, this.options)
    const swiper = this.swiper

    swiper.on('init', () => {
      this.canSwipe()
      swiperEl.classList.add('initialized')
    })
    swiper.on('beforeResize', () => {
      this.canSwipe()
    })
    swiper.init()
  }

  initControls() {
    const swiper = this.swiper
    swiper.on('slideChange', () => this.updateControls())
    this.prevButton.addEventListener('click', () => swiper.slidePrev())
    this.nextButton.addEventListener('click', () => swiper.slideNext())
  }

  updateControls() {
    const swiper = this.swiper
    let buttonDisabledClass = 'disabled'

    if (swiper.isBeginning) {
      this.prevButton.classList.add(buttonDisabledClass)
    } else {
      this.prevButton.classList.remove(buttonDisabledClass)
    }
    if (swiper.isEnd) {
      this.nextButton.classList.add(buttonDisabledClass)
    } else {
      this.nextButton.classList.remove(buttonDisabledClass)
    }
  }

  canSwipe() {
    const swiper = this.swiper
    const canSwipe = swiper.slides.length > swiper.params.slidesPerView
    if (canSwipe) {
      swiper.enable()
      this.swiperEl.classList.remove('disabled')
      this.updateControls()
    } else {
      swiper.disable()
      this.swiperEl.classList.add('disabled')
    }
  }
}

customElements.define('sasag-product-swiper', ProductSwiperComponent)
